import type { FC } from "react";
import { useParams } from "react-router-dom";

import type { IImageLoader } from "@Components/ImageLoader";
import { getAssetsImage } from "@Components/Modules/Helpers";
import * as stylex from "@stylexjs/stylex";

import Share from "../common/Share";
import type { IArticleBox } from "./ArticleBox";
import { ArticleBoxList } from "./ArticleBoxList";
import type { CategoryItem } from "./BlogHelper";
import { postNavigation } from "./BlogNavigation";

import * as css from "./BlogPost.module.css";
import "./wordpress.css";

interface INavigationItem {
    slug: string;
    id: number;
}

export interface IBlogPost {
    title: string;
    subTitle: string;
    id: number;
    innerText: string;
    banner: IImageLoader;
    previousPage?: INavigationItem;
    nextPage?: INavigationItem;
    discountUrl: string;
    relatedArticles: IArticleBox[];
    date: string;
    public: string;
    tags: CategoryItem[];
}

const BlogPost: FC<IBlogPost> = (props) => {
    const { p1 } = useParams();

    return (
        <div className={css.blogPostComponent}>
            {postNavigation(props)}
            <div className={css.header}>
                <img src={getAssetsImage(process.env.CalendarIcon)} alt="calendar icon" />
                <span>{props.date}</span>
            </div>
            <Share
                text="Przeczytaj na blogu"
                shareUrl={`/blog/${p1}/${props.id}`}
                title={props.title}
                appearance="default"
                displayInline
            />
            {props.banner && (
                <img {...stylex.props(styles.image)} src={props.banner.src} alt={props.banner.alt} />
            )}
            <div className="ArticleBody clear" dangerouslySetInnerHTML={{ __html: props.innerText }} />
            <ArticleBoxList data={props.relatedArticles} />
        </div>
    );
};

const styles = stylex.create({
    image: {
        marginBottom: "40px",
    },
});

export default BlogPost;
